var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var Editor = require("../editor.jsx");
var TextInput = require("../components/text-input.jsx");

var defaultExplanationProps = {
    showPrompt: "Explain",
    hidePrompt: "Hide explanation",
    explanation: "explanation goes here\n\nmore explanation",
    widgets: {}
};

var ExplanationEditor = React.createClass({
    displayName: "ExplanationEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        showPrompt: React.PropTypes.string,
        hidePrompt: React.PropTypes.string,
        explanation: React.PropTypes.string,
        widgets: React.PropTypes.object,
        apiOptions: React.PropTypes.any
    }),

    getDefaultProps: function getDefaultProps() {
        return defaultExplanationProps;
    },

    getInitialState: function getInitialState() {
        return {};
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        var _this = this;

        return React.createElement(
            "div",
            { className: "perseus-widget-explanation-editor" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Prompt to show explanation:",
                    " ",
                    React.createElement(TextInput, {
                        value: this.props.showPrompt,
                        onChange: this.change("showPrompt")
                    })
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Prompt to hide explanation:",
                    " ",
                    React.createElement(TextInput, {
                        value: this.props.hidePrompt,
                        onChange: this.change("hidePrompt")
                    })
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(Editor, {
                    apiOptions: this.props.apiOptions,
                    content: this.props.explanation,
                    widgets: this.props.widgets,
                    widgetEnabled: true,
                    immutableWidgets: false,
                    onChange: function onChange(props) {
                        var newProps = {};
                        if (_.has(props, "content")) {
                            newProps.explanation = props.content;
                        }
                        if (_.has(props, "widgets")) {
                            newProps.widgets = props.widgets;
                        }
                        _this.change(newProps);
                    }
                })
            )
        );
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = ExplanationEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/explanation-editor.jsx
 ** module id = 101
 ** module chunks = 0 1
 **/